import ClientInfo from "./ClientInfo";
export default ClientInfo;
